import { Account, Auditable, PersonType, QueryParams, SortParams } from "..";

export interface Person extends Auditable {
    tenantId: number;
    personTypeId?: number;
    userId?: number;
    accountId?: number;
    asnId?: string;
    isCriteriaBased?: boolean;
    firstName: string;
    lastName: string;
    suffix: string;
    title: string;
    email: string;
    phone: string;
    phoneExtension: string;
    cell: string;
    phoneAfterHours: string;
    fax: string;
    preferredContactMethod: string;
    contactType: string;
    contactTypeData: string;
    unitPrimary: string;

    mailingAddress1: string;
    mailingAddress2: string;
    mailingAddressAttn: string;
    mailingAddressCity: string;
    mailingAddressState: string;
    mailingAddressZip: string;

    shippingAddress1: string;
    shippingAddress2: string;
    shippingAddressAttn: string;
    shippingAddressCity: string;
    shippingAddressState: string;
    shippingAddressZip: string;

    assistantName: string;
    assistantPhone: string;
    assistantPhoneExtension: string;
    assistantFax: string;
    assistantEmail: string;

    recipientFormCommunicationType: string;
    recipientFormCommunication: string;
    postopFormCommunicationType: string;
    postopFormCommunication: string;

    notes: string;
    isInternational?: boolean;
    processingCriteria: string;
    shippingCriteria: string;
    dmekCriteria: string;
    cairsCriteria: string;
    precutCriteria: string;
    dsaekMin: string;
    dsaekMax: string;

    personType?: PersonType;
    account?: Account;
}

export enum PreferredContactMethod {
    Email = "email",
    Fax = "fax",
}

export const DefaultPersonQueryParams: QueryParams = {
    firstName: "",
    lastName: "",
    personType: "",
};

export const DefaultPersonSortParams: SortParams = {
    orderBy: "firstName",
    orderDesc: "false",
};
